import styled from '@emotion/styled';
import { APP_IMG } from 'src/constants';
import { controller } from 'src/switch-themes';

const { image } = controller;

const WidgetEmpty = () => {
  return (
    <WidgetWrapper className='no-article'>
      <img src={image?.noArticle || `${APP_IMG}/cache/logo.webp`} title='no-article' alt='no-article' width='100%' height='100%' loading='lazy' />
    </WidgetWrapper>
  );
};

export default WidgetEmpty;

const WidgetWrapper = styled.div`
  display: block;
  max-width: 70%;
  margin: auto;
  img {
    opacity: 0.6;
  }
  @media (max-width: 767px) {
    max-width: 100%;
  }
`;
